import { OPERATORS } from "../constants/operators";

export function operatorIdToName(id) {
  const operator = OPERATORS.find((i) => i.id === id);
  return operator ? operator.name : id;
}
